export const modelStyles = (theme) => ({
    mainDiv: {
        p: 3,
        borderRadius: 1,
        position: "relative",
        boxShadow: 1,
        textAlign: "left",
    },

    flex_start:{
        display: "flex", 
        alignItems: "center", 
        justifyContent: "flex-start", 
        gap: 1, 
        mb: 2
    }
})